import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import ChurchPanel from './ChurchPanel';
import { BaseCard } from '../../../components/wizard';

class ChurchCard extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  render = () => {
    const { record = {}, data = {}, extras, setItem, ...extraProps } = this.props;
    const formdata = data.data || {};
    return (
      <Box>
        <BaseCard
          cardid={'CHURCH'}
          cardname={'Church'}
          cardtitle={'Church & Membership'}
          instruction={'Capture occupation, parish history, groups, and membership metadata.'}
          step={5}
          buttons={['START', 'CANCEL', 'PREV', 'NEXT', 'GUIDE']}
          {...extraProps}
        >
          <ChurchPanel
            data={data}
            record={{ ...record, ...formdata }}
            extras={extras}
            setItem={setItem}
          />
        </BaseCard>
      </Box>
    );
  };
}

ChurchCard.propTypes = {
  classes: PropTypes.object,
};

export default ChurchCard;
